import React, { FC, Fragment } from "react";
import { Box, Button, makeStyles } from "@material-ui/core";
import { color, px } from "Configs/theme";
import { useTranslation } from "Providers/TranslationProvider";
import { getImageUrl } from "Helpers/AssetHelper";
import OrganizationSuggestionModal from "./OrganizationSuggestionModal";
import { useModalController } from "Components/Modal/Modal";
import { TrackingEvent, useTracking } from "../../Providers/TrackingProvider";

interface Props {
  buttonVariant?: "contained";
  padding?: any;
}

const OrganizationSuggestionCtaView: FC<Props> = (props) => {
  const {t} = useTranslation();
  const classes = useStyles();
  const organizationSuggestionMc = useModalController();
  const {trackEvent} = useTracking();

  function openOrganizationModal(): void {
    trackEvent(TrackingEvent.NEW_PARTNER_REQUEST_CLICKED);
    organizationSuggestionMc.open();
  }

  return (
      <Fragment>
        <Box className={classes.root} padding={props.padding}>
          <Box className={classes.content}>
            <Box className={classes.contentImage}>
              <img
                  width="60"
                  src={getImageUrl("organization-suggestion.svg")}
                  alt="Partner Suggestion"
              />
            </Box>
            <Box className={classes.contentMessage}>
              {t("OrganizationSuggestionCtaView_Message")}
            </Box>
            <Box className={classes.contentCta}>
              <Button
                  className={classes.contentCtaButton}
                  onClick={openOrganizationModal}
                  variant={props.buttonVariant}
                  color="primary"
                  disableElevation
              >
                {t("OrganizationSuggestionCtaView_Cta")}
              </Button>
            </Box>
          </Box>
        </Box>
        <OrganizationSuggestionModal modalController={organizationSuggestionMc}/>
      </Fragment>
  );
};

export default OrganizationSuggestionCtaView;

const useStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    borderRadius: px.s,
    backgroundColor: color.card,
    margin: px.m,
    marginLeft: px.none,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    maxWidth: 400,
  },
  contentImage: {
    display: "flex",
    justifyContent: "center",
    marginBottom: px.xl,
  },
  contentMessage: {
    fontSize: "12px",
    textAlign: "center",
    fontWeight: 500,
    marginBottom: px.xl,
  },
  contentCta: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  contentCtaButton: {
    fontSize: "14px",
    fontWeight: "bold",
    marginBottom: px.m,
  },
});
